import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-default-layout',
    imports: [],
    templateUrl: './default.layout.component.html',
    styleUrl: './default.layout.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class DefaultLayoutComponent {

}
